<script lang="ts">
	import SoftwareMockup from "./SoftwareMockup.svelte";
</script>

<div class="grid grid-cols-1 flex-col gap-8 md:grid-cols-2 lg:gap-16 xl:gap-32">
	<div
		class="relative order-2 flex size-full items-center justify-center px-4 md:left-[-21.4375rem] md:px-0 xl:order-1"
	>
		<SoftwareMockup class="h-auto w-full md:w-[69.5rem] md:shrink-0" />
	</div>

	<div
		class="text-ltsecondary order-1 mx-10 flex flex-1 flex-col justify-center md:order-2 md:ml-0 md:mr-[5.125rem] lg:mr-[8.125rem] xl:justify-center"
	>
		<slot />
	</div>
</div>
